import AutoGrowTextarea from '../AutoGrowTextarea';

const URL_REGEX = /^https:\/\/.+\..+/;

export default function EntregavelNode({ id, data }) {
    const entregavelDeliveryType = data?.entregavelDeliveryType || 'vip_link';
    const entregavelText         = data?.entregavelText || '';
    const entregavelUrl          = data?.entregavelUrl || '';
    const entregavelButtonText   = data?.entregavelButtonText || '';

    const change = (patch) => data?.onChangeEntregavel?.(id, patch);
    const urlInvalid = entregavelUrl && !URL_REGEX.test(entregavelUrl);
    // Sem texto de botão, o link é descartado silenciosamente ao montar o
    // teclado (nenhum botão sem texto é enviado) — o entregável quebra.
    const buttonTextMissing = entregavelDeliveryType === 'external_link' && entregavelUrl && !entregavelButtonText.trim();

    return (
        <div className="mt-2 space-y-2">
            <div className="flex items-center gap-1.5">
                <div className="h-px flex-1 bg-blue-500/30" />
                <span className="text-[9px] font-semibold text-blue-400 uppercase tracking-wider">Entregável</span>
                <div className="h-px flex-1 bg-blue-500/30" />
            </div>

            <select className="form-select w-full" value={entregavelDeliveryType}
                onChange={(e) => change({ entregavelDeliveryType: e.target.value })}>
                <option value="vip_link">Link VIP (grupo Telegram)</option>
                <option value="text">Apenas texto</option>
                <option value="external_link">Link externo (botão)</option>
            </select>

            {entregavelDeliveryType === 'vip_link' && (
                <div className="text-[10px] text-gray-400">
                    Envia o link de convite do grupo VIP configurado no bot.
                </div>
            )}

            {entregavelDeliveryType !== 'vip_link' && (
                <AutoGrowTextarea className="spt-textarea border-2"
                    placeholder={entregavelDeliveryType === 'external_link' ? 'Texto acima do botão' : 'Mensagem de entrega'}
                    value={entregavelText}
                    onChange={(e) => change({ entregavelText: e.target.value })} />
            )}

            {entregavelDeliveryType === 'external_link' && (
                <>
                    <input type="text" className={`input3 w-full ${urlInvalid ? 'border-red-500' : ''}`}
                        placeholder="URL (https://...)" value={entregavelUrl}
                        onChange={(e) => change({ entregavelUrl: e.target.value })} />
                    {urlInvalid && (
                        <div className="flex items-center gap-1 text-[10px] text-red-400">
                            <i className="fas fa-exclamation-triangle" />
                            <span>URL inválida. Ex: https://site.com</span>
                        </div>
                    )}
                    <input type="text" className={`input3 w-full ${buttonTextMissing ? 'border-red-500' : ''}`}
                        placeholder="Texto do botão (obrigatório)"
                        value={entregavelButtonText}
                        onChange={(e) => change({ entregavelButtonText: e.target.value })} />
                    {buttonTextMissing && (
                        <div className="flex items-center gap-1 text-[10px] text-red-400">
                            <i className="fas fa-exclamation-triangle" />
                            <span>Preencha o texto do botão, ou o link não será entregue.</span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
